import { CircularProgress } from '@mui/material'
import clsx from 'clsx'
import { Link, OperationButton } from 'components/core-v2'
import QRCode from 'qrcode'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { useGetTwoFactorSetupQuery } from '../../../../../api'
import { PATH } from '../../../../../const'
import { COPY } from './constants'
import classes from './index.module.scss'

const { button, enterTheCode } = COPY

export const SyncAuthyForm = () => {
  const navigate = useNavigate()
  const [qrURL, setQRURL] = useState()

  const { data: secret, isSuccess: isQRSuccess } = useGetTwoFactorSetupQuery()

  const onSubmit = () => navigate(PATH.login)

  useEffect(() => {
    if (isQRSuccess && secret && secret.authenticatorUri) {
      QRCode.toDataURL(secret.authenticatorUri).then(url => {
        setQRURL(url)
      })
    }
  }, [isQRSuccess, secret])

  return (
    <div>
      <p className={classes.text}>
        Download the{' '}
        <Link
          className={classes.link}
          target="_blank"
          to="https://authy.com/download/"
          variant="link"
        >
          Authy authenticator
        </Link>{' '}
        and scan the QR code:
      </p>
      <div className={classes.QRCodeWrapper}>
        {isQRSuccess ? (
          <img data-private alt="QR Code" className={classes.QRCodeWrapper} src={qrURL} />
        ) : (
          <CircularProgress color="inherit" size="20px" />
        )}
      </div>
      <p className={classes.text}>{enterTheCode}</p>
      <p className={clsx(classes.text, classes.code)}>
        {isQRSuccess && secret && secret.sharedKey}
      </p>
      <OperationButton
        className={classes.button}
        operationType="progress"
        type="button"
        width="100%"
        onClick={onSubmit}
      >
        {button}
      </OperationButton>
    </div>
  )
}
